import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { selectGamePlayers, selectViewerId } from "src/store/game"
import { selectGameConfig } from "src/store/common"
import { rosterFor } from "src/utils/battlefield"
import ModalService from "src/modals"

import Modal from "src/components/modals/Modal"
import FormationEditor from "src/components/FormationEditor"
import UnitItem from "src/components/UnitItem"

import "./BattleModal.css"

/* The battle plan, reachable before any battle exists: the same editor the battle view unfolds,
   behind the top bar's FORMACIÓN chip. The editor needs no battle at all — the plan is the
   team's and applies wherever the next fight happens. Spectators never see the chip. */

const FormationModal = () => {
  const { t } = useTranslation()
  const players = useSelector(selectGamePlayers)
  const gameConfig = useSelector(selectGameConfig)
  const userId = useSelector(selectViewerId)
  const team = players.find((p) => p.user.id === userId)?.team
  if (!team) return null

  // Your own side first, then the one you will be fighting.
  const sides = team === "human" ? ["human", "zombie"] : ["zombie", "human"]

  return (
    <Modal width="min(760px, 94%)" isolated={false} scope="map" top="6vh" maxHeight="88vh">
      <div className="formation-modal with-scroll-bar vertical">
        <header className="battle-head">
          <h2>✎ {t("game.formation.title")}</h2>
          <p className="battle-meta">{t("game.formation.subtitle")}</p>
        </header>
        <FormationEditor team={team} onSaved={() => ModalService.hide("FormationModal")} />

        {/* The troops, both sides (owner's ask, 2026-09-20): the plan above names units by their
            names alone, and the only place their sheets could be opened from was a garrison or a
            battle — which is to say, once it was too late to plan around them. Every chip opens
            the same unit sheet a city's chip does. */}
        <section className="formation-troops" aria-label={t("game.formation.troops")}>
          <p className="section-label">{t("game.formation.troops")}</p>
          <p className="formation-troops-hint">{t("game.formation.troopsHint")}</p>
          {sides.map((side) => (
            <div className="formation-troops-side" key={side}>
              <p className={`formation-troops-team ${side}`}>
                {t(`game.battle.${side}`)}
                {side === team ? <span className="formation-troops-yours"> · {t("game.formation.yourSide")}</span> : null}
              </p>
              <div className="formation-troops-units">
                {rosterFor(gameConfig, side).map((unit) => (
                  <UnitItem key={unit} type={unit} count={null} showLabel />
                ))}
              </div>
            </div>
          ))}
        </section>
      </div>
    </Modal>
  )
}

export default FormationModal
